// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mAMfY","controls":"styles_controls__NJUPw","charLimit":"styles_charLimit__1EG-s","input":"styles_input__MpafN","send":"styles_send__2anMM"};